import md5 from 'md5';

export function darkenColor(hexColor, amount) {
  amount = typeof amount !== 'undefined' ? amount : 0.4;
  hexColor = hexColor.replace('#', '');
  const rgb = hexColor.match(/.{1,2}/g).map((color) => parseInt(color, 16));

  rgb[0] = Math.round(parseInt(rgb[0]) * amount);
  rgb[1] = Math.round(parseInt(rgb[1]) * amount);
  rgb[2] = Math.round(parseInt(rgb[2]) * amount);

  return '#' + (0x1000000 + (rgb[2] | (rgb[1] << 8) | (rgb[0] << 16))).toString(16).slice(1);
}

export function stringToColor(text, amount) {
  amount = typeof amount !== 'undefined' ? amount : 0.8;

  return darkenColor(md5(text).substring(0, 6), amount);
}

export default {
  darkenColor,
  stringToColor,
};
